var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"faqs faqs--sub"},[_c('h3',{staticClass:"faqs__head"},[_vm._v("Subscription FAQS")]),_vm._v(" "),_vm._l((_vm.faqs),function(faq,index){return _c('question',{key:index,attrs:{"question":faq.question,"answer":faq.answer}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }